import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'ID',
        label: 'id',
        defaultShow: true,
        type: 'number',
    },
    {
        key: 'CREATED_AT',
        label: 'createdAt',
        type: 'dateTime',
        defaultShow: true,
    },
    {
        key: 'FINAL_PRODUCT_SKU',
        label: 'finalProductSku',
        defaultShow: true,
    },
    {
        key: 'NAME',
        label: 'name',
        defaultShow: true,
    },
    {
        key: 'ACTIVE',
        label: 'active',
        type: 'select',
        defaultShow: true,
        customRender: true,
        selectOption: 'boolNumberCodes',
        customStyle: { padding: '1px 11px 1px 16px' },
    },
];
